import React, { useCallback } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Divider } from "antd";
import { Content } from "@worcket/common/components/layout";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import MultipostingForm from "../../../scenes/Opportunity/routes/OpportunityDetails/MultipostingForm/MultipostingForm";
import {
  GO_TO_NEXT_WIZARD_STEP,
  GO_TO_PREVIOUS_WIZARD_STEP,
  SAVE_MULTIPOSTING_FORM,
  SAVE_SCRAPPER_FORM,
  SAVE_MULTIPOSTING_UNIVERSITIES_FORM,
  SAVE_SHAREDEMAIL_FORM,
  SAVE_AUTO_INVITE_EXTERNAL_CANDIDATES
} from "../../../store/actions/opportunity";
import UniversityList from "../../../components/List/UniversityList";
import Button from "../../../components/Button";

import JobEmailForm from "./JobEmailForm";
import AutoInviteExternalCandidates from "./AutoInviteExternalCandidates";

import styled from "styled-components/macro";

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`;

const Publish = ({
  opportunity,
  t,
  goToPreviousStep,
  goToNextStep,
  company
}) => {
  const dispatch = useDispatch();

  const [multiposting, setMultiposting] = React.useState(
    R.prop("multiposting", opportunity)
  );
  const [publishedOnCompanies, setPublishedOnCompanies] = React.useState([]);
  const [initialPublishedOnCompanies] = React.useState(
    R.pipe(
      R.propOr([], "publishedOnCompanies"),
      R.map(R.prop("idCompany"))
    )(opportunity)
  );
  const [createJobPostEmail, setCreateJobPostEmail] = React.useState(
    R.propOr(true, "createJobPostEmail", opportunity)
  );
  const [
    autoInviteExternalCandidates,
    setAutoInviteExternalCandidates
  ] = React.useState(
    R.propOr(true, "autoInviteExternalCandidates", opportunity)
  );

  const onChangeSelected = useCallback(
    selected =>
      setPublishedOnCompanies(
        selected.map(({ id }) => ({ idCompany: id, enabled: true }))
      ),
    []
  );

  const handleStepChange = useCallback(() => {
    if (multiposting) {
      dispatch(SAVE_MULTIPOSTING_FORM.run(multiposting.multiposting));
      dispatch(SAVE_SCRAPPER_FORM.run(multiposting.scrapper));
    }
    dispatch(SAVE_MULTIPOSTING_UNIVERSITIES_FORM.run(publishedOnCompanies));
    dispatch(SAVE_SHAREDEMAIL_FORM.run(createJobPostEmail));
    dispatch(
      SAVE_AUTO_INVITE_EXTERNAL_CANDIDATES.run(autoInviteExternalCandidates)
    );
  }, [
    autoInviteExternalCandidates,
    createJobPostEmail,
    dispatch,
    multiposting,
    publishedOnCompanies
  ]);

  return (
    <Content>
      <h2>{t("opportunity:wizard.steps.publishing")}</h2>
      <p>{t("opportunity:wizard.publishing.description")}</p>
      <Divider />
      <MultipostingForm parentForm={setMultiposting} />
      <Divider />
      {company.type !== "university" && (
        <UniversityList
          type="wizard"
          onChangeSelected={onChangeSelected}
          initialSelected={initialPublishedOnCompanies}
        />
      )}
      <JobEmailForm
        createJobPostEmail={createJobPostEmail}
        setCreateJobPostEmail={setCreateJobPostEmail}
      />
      <Divider />
      <AutoInviteExternalCandidates
        onChange={setAutoInviteExternalCandidates}
        enabled={autoInviteExternalCandidates}
      />
      <Divider />
      <ActionsContainer>
        <Button
          size="lg"
          onClick={() => {
            goToPreviousStep();
          }}
          type="quaternary"
        >
          {t("global:back")}
        </Button>

        <Button
          type="primary"
          size="lg"
          data-test="next-step-btn"
          onClick={() => {
            handleStepChange();
            goToNextStep();
          }}
        >
          {t("global:next")}
        </Button>
      </ActionsContainer>
    </Content>
  );
};

const enhancer = compose(
  withTranslation(["opportunity"]),
  connect(
    state => ({
      company: R.propOr({}, "company", state)
    }),
    {
      goToPreviousStep: GO_TO_PREVIOUS_WIZARD_STEP.run,
      goToNextStep: GO_TO_NEXT_WIZARD_STEP.run
    }
  )
);

export default enhancer(Publish);
